import { render, staticRenderFns } from "./ApplicationRoot.vue?vue&type=template&id=ec98e438"
import script from "./ApplicationRoot.vue?vue&type=script&lang=js"
export * from "./ApplicationRoot.vue?vue&type=script&lang=js"
import style0 from "./ApplicationRoot.vue?vue&type=style&index=0&id=ec98e438&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports